/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disqualification penalty`)
};

const es_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalización por descalificación`)
};

const de_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disqualifikationsstrafe`)
};

const nl_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskwalificatiestraf`)
};

const fr_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pénalité de disqualification`)
};

const it_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalità squalifica`)
};

const pt_br2_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalidade de desclassificação`)
};

const pt_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalidade de desqualificação`)
};

const ja_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失格ペナルティ`)
};

const zh_f1_points_legend_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消资格惩罚`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_legend_dq = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_legend_dq(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_legend_dq", locale)
	if (locale === "en") return en_f1_points_legend_dq(inputs)
	if (locale === "es") return es_f1_points_legend_dq(inputs)
	if (locale === "de") return de_f1_points_legend_dq(inputs)
	if (locale === "nl") return nl_f1_points_legend_dq(inputs)
	if (locale === "fr") return fr_f1_points_legend_dq(inputs)
	if (locale === "it") return it_f1_points_legend_dq(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_legend_dq(inputs)
	if (locale === "pt") return pt_f1_points_legend_dq(inputs)
	if (locale === "ja") return ja_f1_points_legend_dq(inputs)
	return zh_f1_points_legend_dq(inputs)
};